import { mapGetters, mapState } from 'vuex'

export default{
    data() {
        return {
             url: null, lastModified: null
        }
    },
    computed: {
        ...mapGetters({
            display: 'contact/display',
            activeTab: 'contact/activeTab',
            selectedUser: 'contact/selectedUser'
        }),
        ...mapState({
            menu:(state)=>state.contact.personal,
          }),
       
    },
    methods: {
        readURL(e, item) {
            var files = e.target.files[0];
            this.url = URL.createObjectURL(files)
            item.imgUrl = this.url
        },
        activeDiv(item) {
            this.$store.dispatch('contact/active', item)
        },
        printContact(item) {
            this.$store.commit('contact/print', item)
          
        },
        getImgUrl(path) {
            return require('@/assets/images/' + path)
        },
        editContact() {
            this.$store.dispatch('contact/change')
        },
        deleteContact: function (value,index) {
            this.$swal({
                icon: 'warning', title: "Are you sure?", text: 'Once deleted, you will not be able to recover this imaginary file!',
                showCancelButton: true, confirmButtonText: 'Ok',
                confirmButtonColor: '#e64942', cancelButtonText: 'Cancel', cancelButtonColor: '#efefef',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.menu.splice(this.menu.indexOf(value), 1);
                    if (index === this.menu.length) {
                      if (this.menu.length > 0) {
                        this.menu[0].active = true;
                      }
                    }
                    if (this.menu.length !== index) {
                      this.menu[index].active = true;
                    }
                  } else {
                    this.$swal({
                      text: 'Your contact is safe!',
                      confirmButtonColor: 'var(--theme-default)',
                    });
                  }
            });
        },
        changeDetails(details) {
            if (!details.active) {
              this.menu.forEach((data) => {
              
                if (this.menu.includes(details)) {
      
                  data.active = false;
                }
              });
              details.active = !details.active;
            }
          }
    }
}